/**
 * On the backend this is called pack_id, but this is an enum, not really an id
 */
export enum ApiCreditPackIdentifier {
  JOB_PACK_3 = 'JOB_PACK_3',
  JOB_PACK_10 = 'JOB_PACK_10',
  JOB_PACK_20 = 'JOB_PACK_20',
  JOB_PACK_25 = 'JOB_PACK_25',
  JOB_PACK_30 = 'JOB_PACK_30',
  JOB_PACK_50 = 'JOB_PACK_50',
  JOB_PACK_100 = 'JOB_PACK_100',
  JOB_PACK_500 = 'JOB_PACK_500',
  INTERNSHIP_PACK_10 = 'INTERNSHIP_PACK_10',
}
